import axios from "@/axios-auth";

const state = {
  campanhaPendente: null,
};

const mutations = {
  setCampanhaPendente: (state, campanha) => {
    state.campanhaPendente = campanha || null;
  },
};

const getters = {
  campanhaPendente: (state) => state.campanhaPendente,
};

const actions = {
  // Descoberta de campanha nova para quem ja esta logado: campanhaPendente so
  // era preenchido no login e no boot do SPA (/users/perfil), entao uma campanha
  // criada com a pessoa ja logada so aparecia depois de recarregar a pagina.
  buscarCampanhaPendente: async ({ commit }) => {
    const res = await axios.get("/campanhas/pendente");

    if (res.error || !res.data || res.data.success === false) {
      return { ok: false, campanha: null };
    }

    const payload = (res.data && res.data.data) || {};
    const campanha = payload.campanha_pendente || null;

    if (campanha) {
      commit("setCampanhaPendente", campanha);
    }

    return { ok: true, campanha };
  },
  buscarStatusCampanha: async ({ state }, campanhaId) => {
    const id = campanhaId || (state.campanhaPendente && state.campanhaPendente.id);
    const res = await axios.get(`/campanhas/${id}/status`);

    if (res.error || !res.data || res.data.success === false) {
      return { ok: false, respondida: false };
    }

    const payload = (res.data && res.data.data) || {};
    return { ok: true, respondida: !!payload.respondida };
  },
  responderCampanha: async ({ commit }, { campanhaId, opcaoId }) => {
    const res = await axios.post(`/campanhas/${campanhaId}/responder`, { opcao_id: opcaoId });

    if (res.error) {
      const erroPayload = res.error.response && res.error.response.data && res.error.response.data.data;
      const codigo = erroPayload && erroPayload.codigo;
      return { ok: false, jaRespondida: codigo === "CAMPANHA_JA_RESPONDIDA" };
    }

    commit("setCampanhaPendente", null);
    const payload = (res.data && res.data.data) || {};
    return { ok: true, opcao: payload };
  },
};

export default {
  state,
  mutations,
  getters,
  actions,
};
